// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* App.css */

/* Root Variables */
:root {
  --background-color: #121212; /* App background color */
  --background-secondary-color: #191919;
  --primary-color: #191919;
  --text-color-primary: #f7f5f2;
  --btn-hover-color: #b5e82a;
  --btn-selected-color: #d2fc61;
  --white: #faf0e6;
}

/* Global Font */
body {
  font-family: Poppins, sans-serif;
  min-width: 360px; /* Set a minimum width for the entire site */
  width: 100%;
  overflow-x: auto;
}

/* Sidebar Sider Styles */
.sider {
  overflow: auto;
  height: auto;
  inset-inline-start: 0;
  width: 250px;
  top: 0;
  bottom: 0;
  scrollbar-width: thin;
  scrollbar-color: unset;
  position: relative;
  background-color: var(--background-secondary-color);
}

/* Logo Container */
.logo-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
  margin-top: 40px;
}

/* White Line Divider */
.line-divider {
  height: 1px;
  width: 50%;
  background-color: white;
  margin: 0 auto 20px auto;
}

/* Custom Menu Styles */
.menu {
  background-color: var(--background-secondary-color) !important;
  font-family: 'Poppins', sans-serif !important;
  padding-left: 10px;
  padding-right: 10px;
}

/* Custom style for selected menu item */
.ant-menu-item-selected {
  background-color: var(--btn-selected-color) !important;
  color: var(--text-color-primary) !important;
}

/* Custom hover style for menu items */
.ant-menu-item:hover {
  background-color: var(--btn-hover-color) !important;
}
/* Sidebar specific styles */
.sider {
  /* position: fixed; */
  top: 0;
  left: 0;
  bottom: 0;
  width: 250px;
  background-color: var(--background-secondary-color);
  /* overflow-y: auto; */
}

.logo-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
  margin-top: 40px;
}

.line-divider {
  height: 1px;
  width: 50%;
  background-color: white;
  margin: 0 auto 20px auto;
}

/* Main content area */
.ant-layout-content {
  /* padding: 204px; */
  padding: 24px;
  margin-left: 250px; /* Matches the width of the sidebar */
  background-color: var(--background-color);
  overflow-y: auto;
}

.menu {
  padding-left: 10px;
  padding-right: 10px;
  font-family: 'Poppins', sans-serif;
}

/* Carousel Styles */
.carousel-container {
  position: relative;
}

.carousel-slide {
  position: relative;
}

.carousel-title {
  position: absolute;
  bottom: 10%;
  left: 50%;
  transform: translateX(-50%);
  color: white;
  font-size: 2rem;
  font-weight: bold;
}
/* Custom Footer Styles */
.footer-custom {
  font-family: 'Poppins', sans-serif; /* Using the Poppins font */
  letter-spacing: 0.05em; /* Slightly increase letter spacing */
  background-color: var(--background-secondary-color);
  padding-top: 2.5rem; /* Equivalent to py-10 in Tailwind */
  padding-bottom: 2.5rem;
  padding-left: 3rem; /* Equivalent to px-12 in Tailwind */
  padding-right: 3rem;
  text-align: center; /* Center-align content */
  color: white; /* Text color white */
  margin-left: 250px;
  overflow-y: auto;
}

/* Add responsiveness for smaller screens */
/* @media (max-width: 768px) { */
/* .footer-custom { */
/* padding-left: 1.5rem; Adjust padding for mobile screens */
/* padding-right: 1.5rem; */
/* } */
/* } */

/* Mobile View Layout Adjustments */
@media (max-width: 500px) {
  /* Adjusting content padding and layout for mobile */
  .ant-layout-content {
    margin-left: 0; /* Remove sidebar margin */
    padding-left: 0;
    padding-right: 0;
  }

  /* Sidebar width and visibility for mobile */
  .sider {
    width: 100%; /* Full width for mobile */
    position: fixed; /* Keep sidebar fixed */
    left: 0;
  }

  /* Footer padding adjustments */
  .footer-custom {
    padding-left: 10px;
    padding-right: 10px;
  }
}

/* Apply the same background color for submenu items */
.ant-menu-sub {
  background-color: var(
    --background-secondary-color
  ) !important; /* Same background as parent */
}

.ant-menu-submenu-title:hover {
  background-color: var(
    --btn-hover-color
  ) !important; /* Hover color for submenu title */
}

/* Customize the hover state for submenu items */
.ant-menu-submenu .ant-menu-item:hover {
  background-color: var(--btn-hover-color) !important; /* Add hover effect */
}

/* Apply selected color for the submenu items */
.ant-menu-submenu .ant-menu-item-selected {
  background-color: var(--btn-selected-color) !important;
  color: var(--text-color-primary) !important;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,YAAY;;AAEZ,mBAAmB;AACnB;EACE,2BAA2B,EAAE,yBAAyB;EACtD,qCAAqC;EACrC,wBAAwB;EACxB,6BAA6B;EAC7B,0BAA0B;EAC1B,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA,gBAAgB;AAEd;EAAA,gCAAmB;EACnB,gBAAgB,EAAE,4CAA4C;EAC9D,WAAW;EACX;AAHmB;;AAMrB,yBAAyB;AACzB;EACE,cAAc;EACd,YAAY;EACZ,qBAAqB;EACrB,YAAY;EACZ,MAAM;EACN,SAAS;EACT,qBAAqB;EACrB,sBAAsB;EACtB,kBAAkB;EAClB,mDAAmD;AACrD;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE,WAAW;EACX,UAAU;EACV,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA,uBAAuB;AACvB;EACE,8DAA8D;EAC9D,6CAA6C;EAC7C,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,wCAAwC;AACxC;EACE,sDAAsD;EACtD,2CAA2C;AAC7C;;AAEA,sCAAsC;AACtC;EACE,mDAAmD;AACrD;AACA,4BAA4B;AAC5B;EACE,qBAAqB;EACrB,MAAM;EACN,OAAO;EACP,SAAS;EACT,YAAY;EACZ,mDAAmD;EACnD,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA,sBAAsB;AACtB;EACE,oBAAoB;EACpB,aAAa;EACb,kBAAkB,EAAE,qCAAqC;EACzD,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,2BAA2B;EAC3B,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;AACA,yBAAyB;AACzB;EACE,kCAAkC,EAAE,2BAA2B;EAC/D,sBAAsB,EAAE,qCAAqC;EAC7D,mDAAmD;EACnD,mBAAmB,EAAE,oCAAoC;EACzD,sBAAsB;EACtB,kBAAkB,EAAE,oCAAoC;EACxD,mBAAmB;EACnB,kBAAkB,EAAE,yBAAyB;EAC7C,YAAY,EAAE,qBAAqB;EACnC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,2CAA2C;AAC3C,gCAAgC;AAChC,qBAAqB;AACrB,4DAA4D;AAC5D,2BAA2B;AAC3B,MAAM;AACN,MAAM;;AAEN,mCAAmC;AACnC;EACE,oDAAoD;EACpD;IACE,cAAc,EAAE,0BAA0B;IAC1C,eAAe;IACf,gBAAgB;EAClB;;EAEA,4CAA4C;EAC5C;IACE,WAAW,EAAE,0BAA0B;IACvC,eAAe,EAAE,uBAAuB;IACxC,OAAO;EACT;;EAEA,+BAA+B;EAC/B;IACE,kBAAkB;IAClB,mBAAmB;EACrB;AACF;;AAEA,sDAAsD;AACtD;EACE;;cAEY,EAAE,8BAA8B;AAC9C;;AAEA;EACE;;cAEY,EAAE,kCAAkC;AAClD;;AAEA,gDAAgD;AAChD;EACE,mDAAmD,EAAE,qBAAqB;AAC5E;;AAEA,+CAA+C;AAC/C;EACE,sDAAsD;EACtD,2CAA2C;AAC7C","sourcesContent":["/* App.css */\n\n/* Root Variables */\n:root {\n  --background-color: #121212; /* App background color */\n  --background-secondary-color: #191919;\n  --primary-color: #191919;\n  --text-color-primary: #f7f5f2;\n  --btn-hover-color: #b5e82a;\n  --btn-selected-color: #d2fc61;\n  --white: #faf0e6;\n}\n\n/* Global Font */\nbody {\n  @apply font-poppins;\n  min-width: 360px; /* Set a minimum width for the entire site */\n  width: 100%;\n  overflow-x: auto;\n}\n\n/* Sidebar Sider Styles */\n.sider {\n  overflow: auto;\n  height: auto;\n  inset-inline-start: 0;\n  width: 250px;\n  top: 0;\n  bottom: 0;\n  scrollbar-width: thin;\n  scrollbar-color: unset;\n  position: relative;\n  background-color: var(--background-secondary-color);\n}\n\n/* Logo Container */\n.logo-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-bottom: 20px;\n  margin-top: 40px;\n}\n\n/* White Line Divider */\n.line-divider {\n  height: 1px;\n  width: 50%;\n  background-color: white;\n  margin: 0 auto 20px auto;\n}\n\n/* Custom Menu Styles */\n.menu {\n  background-color: var(--background-secondary-color) !important;\n  font-family: 'Poppins', sans-serif !important;\n  padding-left: 10px;\n  padding-right: 10px;\n}\n\n/* Custom style for selected menu item */\n.ant-menu-item-selected {\n  background-color: var(--btn-selected-color) !important;\n  color: var(--text-color-primary) !important;\n}\n\n/* Custom hover style for menu items */\n.ant-menu-item:hover {\n  background-color: var(--btn-hover-color) !important;\n}\n/* Sidebar specific styles */\n.sider {\n  /* position: fixed; */\n  top: 0;\n  left: 0;\n  bottom: 0;\n  width: 250px;\n  background-color: var(--background-secondary-color);\n  /* overflow-y: auto; */\n}\n\n.logo-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-bottom: 20px;\n  margin-top: 40px;\n}\n\n.line-divider {\n  height: 1px;\n  width: 50%;\n  background-color: white;\n  margin: 0 auto 20px auto;\n}\n\n/* Main content area */\n.ant-layout-content {\n  /* padding: 204px; */\n  padding: 24px;\n  margin-left: 250px; /* Matches the width of the sidebar */\n  background-color: var(--background-color);\n  overflow-y: auto;\n}\n\n.menu {\n  padding-left: 10px;\n  padding-right: 10px;\n  font-family: 'Poppins', sans-serif;\n}\n\n/* Carousel Styles */\n.carousel-container {\n  position: relative;\n}\n\n.carousel-slide {\n  position: relative;\n}\n\n.carousel-title {\n  position: absolute;\n  bottom: 10%;\n  left: 50%;\n  transform: translateX(-50%);\n  color: white;\n  font-size: 2rem;\n  font-weight: bold;\n}\n/* Custom Footer Styles */\n.footer-custom {\n  font-family: 'Poppins', sans-serif; /* Using the Poppins font */\n  letter-spacing: 0.05em; /* Slightly increase letter spacing */\n  background-color: var(--background-secondary-color);\n  padding-top: 2.5rem; /* Equivalent to py-10 in Tailwind */\n  padding-bottom: 2.5rem;\n  padding-left: 3rem; /* Equivalent to px-12 in Tailwind */\n  padding-right: 3rem;\n  text-align: center; /* Center-align content */\n  color: white; /* Text color white */\n  margin-left: 250px;\n  overflow-y: auto;\n}\n\n/* Add responsiveness for smaller screens */\n/* @media (max-width: 768px) { */\n/* .footer-custom { */\n/* padding-left: 1.5rem; Adjust padding for mobile screens */\n/* padding-right: 1.5rem; */\n/* } */\n/* } */\n\n/* Mobile View Layout Adjustments */\n@media (max-width: 500px) {\n  /* Adjusting content padding and layout for mobile */\n  .ant-layout-content {\n    margin-left: 0; /* Remove sidebar margin */\n    padding-left: 0;\n    padding-right: 0;\n  }\n\n  /* Sidebar width and visibility for mobile */\n  .sider {\n    width: 100%; /* Full width for mobile */\n    position: fixed; /* Keep sidebar fixed */\n    left: 0;\n  }\n\n  /* Footer padding adjustments */\n  .footer-custom {\n    padding-left: 10px;\n    padding-right: 10px;\n  }\n}\n\n/* Apply the same background color for submenu items */\n.ant-menu-sub {\n  background-color: var(\n    --background-secondary-color\n  ) !important; /* Same background as parent */\n}\n\n.ant-menu-submenu-title:hover {\n  background-color: var(\n    --btn-hover-color\n  ) !important; /* Hover color for submenu title */\n}\n\n/* Customize the hover state for submenu items */\n.ant-menu-submenu .ant-menu-item:hover {\n  background-color: var(--btn-hover-color) !important; /* Add hover effect */\n}\n\n/* Apply selected color for the submenu items */\n.ant-menu-submenu .ant-menu-item-selected {\n  background-color: var(--btn-selected-color) !important;\n  color: var(--text-color-primary) !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
